import React from 'react';
import PropTypes from 'prop-types';

import { FieldWrapper, Button } from './css';
import { thirdPartyUrls } from '../../utils/constant';

const FieldComplexLeadButton = ({ data }) => {
  const { name, label } = data;
  const handleRedirection = () => {
    window.open(thirdPartyUrls.complexLeadUrl, '_blank');
    window.focus();
  };
  return (
    <FieldWrapper>
      <Button
        type="button"
        name={name}
        className="frg-button color-green"
        onClick={() => handleRedirection()}
      >
        {label}
      </Button>
    </FieldWrapper>
  );
};

FieldComplexLeadButton.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string
  }).isRequired
};

export default FieldComplexLeadButton;
